import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import dashboardService, { getTotalApplicationsByType } from "../../services/dashboard-service";
import sectionService from "../../services/section-service";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment from "moment/moment";
import 'moment/locale/es';
import config from "../../config/config";
import BarLineChart from "../DashBoard/BarLineChart";
import BarLineLineChart from "../DashBoard/BarLineLineChart";
import Select from "react-select";
import BarLineLineChartV2 from "../DashBoard/BarLineLineChartV2";
import BarChart from "../DashBoard/BarChart";
import BarCharTwo from "../DashBoard/BarChartTwo";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const OperatingPerformance = () => {

  const blueColor = "#5470C6"
  const greenColor = "#18B8B3"
  const greenColor2 = "#00796B"
  const terracotaColor = "#C65D2E"
  const orangeColor = "#ff7f50"
  const bluePetroilColor = "#1565A8"
  const purpleColor = "#6A4C93"


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);
  const chartFiveRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////
  const [listUsers, setListUsers] = useState([]) ///x value
  const [listTotalHectaresUser, setListTotalHectaresUser] = useState([])
  const [listTotalApplicationsUser, setListTotalApplicationsUser] = useState([])
  const [listWorkDaysUser, setListWorkDaysUser] = useState([])

  /////PROMEDIOS DE USUARIO////////////  
  const [listAverageApplicationsUser, setListAverageApplicationsUser] = useState([])
  const [listAverageHectaresUser, setListAverageHectaresUser] = useState([])
  const [listAverageHectaresApplication, setListAverageHectaresApplication] = useState([])


  const [serieTotalHectaresDay, setSerieTotalHectaresDay] = useState([])
  const [listTotalHectaresDay, setListTotalHectaresDay] = useState([])
  const [listTotalApplicationsDay, setListTotalApplicationsDay] = useState([])


  const [valuesUserX, setValuesUserX] = useState([])
  const [valuesUserY, setValuesUserY] = useState([])
  const [valuesUserYQ, setValuesUserYQ] = useState([])


  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");






  // Usuarios y valores combinados para el quinto gráfico
  const combinedUsers = Array.from(
    new Set([...valuesUserX, ...listUsers])
  );

  // Relacionamos cada usuario con su promedio de aplicaciones
  const applicationsByUser = new Map(
    valuesUserX.map((user, index) => [
      user,
      Number(valuesUserY[index]) || 0
    ])
  );

  // Relacionamos cada usuario con su promedio de hectáreas
  const hectaresByUser = new Map(
    listUsers.map((user, index) => [
      user,
      Number(listAverageHectaresUser[index]) || 0
    ])
  );

  // Construimos los valores en el orden de combinedUsers
  const combinedApplications = combinedUsers.map(
    user => applicationsByUser.get(user) ?? 0
  );

  const combinedHectares = combinedUsers.map(
    user => hectaresByUser.get(user) ?? 0
  );




  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////


  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };



  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }

  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };

  ///APLICACIONES POR USUARIO  
  const getTotalApplicationsByUser = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setValuesUserX([])
    setValuesUserY([])
    setValuesUserYQ([])
    const result = await dashboardService.getTotalApplicationsByUser(start, end, farmId, lotId, sectionId, selectedLotes);
    let listX = [];
    let listY = [];
    let listYQ = [];
    if (result) {
      result.map((item) => {
        const userName = item.userName;
        const total = item.total;
        const rounded = Math.round(item.average)

        listX.push(userName)
        listY.push(rounded)
        listYQ.push(total)
      });
    }
    setValuesUserX(listX)
    setValuesUserY(listY)
    setValuesUserYQ(listYQ)


    console.log(listX)
    console.log(listY)

  };



  /// COORRELACION APLICACIONES POR USUARIO  
  const hectaresApplicationsByUser = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setListUsers([])
    setListTotalHectaresUser([])
    setListTotalApplicationsUser([])
    setListWorkDaysUser([])
    const result = await dashboardService.hectaresApplicationsByUser(start, end, farmId, lotId, sectionId, selectedLotes);
    let listUser = [];
    let listHect = [];
    let listAppl = [];
    let listDays = [];


    let listAveAppl = [];
    let listAveHect = [];
    let listAveAppHect = [];



    if (result) {
      result.map((item) => {
        const user = item.userName;
        const hect = item.totalHectares;
        const appl = item.totalApplications;
        let days = item.workDays;

        if (days == 0) {
          days = 1
        }
        const averageApplications = appl / days;
        let averageHectares = hect / days;
        if (averageHectares == 0) averageHectares = 1;
        const appHec = averageApplications / averageHectares;

        listUser.push(user)
        listHect.push(hect.toFixed(2))
        listAppl.push(appl)
        listDays.push(days)


        listAveAppl.push(averageApplications.toFixed(0))
        listAveHect.push(averageHectares.toFixed(2))
        listAveAppHect.push(appHec.toFixed(2))


      });
    }
    setListUsers(listUser)
    setListTotalHectaresUser(listHect)
    setListTotalApplicationsUser(listAppl)
    setListWorkDaysUser(listDays)


    setListAverageApplicationsUser(listAveAppl)
    setListAverageHectaresUser(listAveHect)
    setListAverageHectaresApplication(listAveAppHect)
  };


  /// COORRELACION HECTAREAS VS APLICACIONES DAY
  const hectaresApplicationsByDay = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setSerieTotalHectaresDay([])
    setListTotalHectaresDay([])
    setListTotalApplicationsDay([])
    const result = await dashboardService.hectaresApplications(start, end, farmId, lotId, sectionId, selectedLotes);
    let listX = [];
    let listHect = [];
    let listAppl = [];
    if (result) {
      result.map((item) => {
        const day = formatDate(item.date);
        const hect = item.totalHectares;
        const appl = item.totalApplications;
        listX.push(day)
        listHect.push(hect.toFixed(2))
        listAppl.push(appl)
      });
    }
    setSerieTotalHectaresDay(listX)
    setListTotalHectaresDay(listHect)
    setListTotalApplicationsDay(listAppl)
  };

  const loadDashBoard = () => {
    hectaresApplicationsByDay()
    hectaresApplicationsByUser()
    getTotalApplicationsByUser()
  };

  useEffect(() => {
    getLisFarm();
    loadDashBoard()
  }, []);

  const {
    register,
    formState: { errors },
  } = useForm();



  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Rendimiento operativo</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form className="form-react">
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>

              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>

              <div className="mt-2 col-6 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Minimizar grafica</label>
                </div>
              </div>

            </div>
          </form>
        </div>





        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarCharTwo
              chartRef={chartFiveRef}
              title="Promedio de aplicaciones y hectáreas por usuario"
              subTitle=""
              categories={combinedUsers}
              nameBar="Aplicaciones promedio"
              applications={combinedApplications}
              barColor={blueColor}
              nameBar2="Hectáreas promedio"
              applications2={combinedHectares}
              barColor2={greenColor}
              decimals={0}
              decimals2={2}
            />

            <Button
              color="default"
              variant="outlined"
              onClick={() =>
                saveAsImage(
                  chartFiveRef,
                  "promedio-aplicaciones-hectareas-usuarios.jpeg"
                )
              }
            >
              <CloudDownloadOutlined className="fa-lg" />
              Descargar
            </Button>
          </div>
        </div>



        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarChart
              decimals={0}
              chartRef={chartOneRef}
              title="Promedio de aplicaciones por usuario"
              subTitle=""
              nameBar="Aplicaciones"
              categories={valuesUserX}
              applications={valuesUserY}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "promedio-aplicaciones-usuarios.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarChart
              decimals={0}
              chartRef={chartTwoRef}
              title="Aplicaciones por usuario"
              subTitle="Cantidad de aplicaciones por usuario"
              nameBar="Aplicaciones"
              categories={valuesUserX}
              applications={valuesUserYQ}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "cantidad-aplicaciones-usuarios.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarChart
              decimals={2}
              chartRef={chartThreeRef}
              title="Promedio de hectáreas por usuario"
              subTitle=""
              barColor={greenColor}
              nameBar="Hetáreas"
              categories={listUsers}
              applications={listAverageHectaresUser}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartThreeRef, "promedio-hectareas-usuarios.jpeg")}            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarChart
              decimals={2}
              chartRef={chartFourRef}
              title="Hectáreas por usuario"
              subTitle=""
              barColor={greenColor}
              nameBar="Hetáreas"
              categories={listUsers}
              applications={listTotalHectaresUser}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartFourRef, "cantidad-hectareas-usuarios.jpeg")}            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


      </div>
    </div>
  );
};

export default OperatingPerformance;
